//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { RedemptionLocationValidationRules } from '@campaigns/types/sampling/SamplingRedemptionLocationsValidationTypes';
import { URL_REGEX_PROTOCOL_ONLY } from '@utils/urlValidation';

export const REDEMPTION_LOCATION_VALIDATION_RULES: RedemptionLocationValidationRules =
  {
    retailerName: {
      required: {
        value: true,
        message: 'Please enter a location name',
      },
    },
    locatorLink: {
      pattern: {
        value: new RegExp(URL_REGEX_PROTOCOL_ONLY),
        message: 'Please enter a valid URL',
      },
    },
  };

export const PDP_URL_VALIDATION_RULES = {
  pattern: {
    value: new RegExp(URL_REGEX_PROTOCOL_ONLY),
    message: 'Please enter a valid URL',
  },
};
